exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dialog-body[data-v-2633a5a2] {\n  margin: 50px 10px;\n}\n.btn-blue[data-v-2633a5a2] {\n  padding: auto;\n}", ""]);

// exports
